export function buildCalendarData(values, user) {
  const userId = user?.uid ?? "";
  const sortedSelectedDates = [...values.selectedDates].sort();

  return {
    ...values,
    selectedDates: sortedSelectedDates,
    metadata: {
      createdBy: userId,
      updatedBy: userId,
    },
  };
}
